import * as React from "react";
import { ReviewTileItem } from "@/types/tile.types";
import { getTileContentAsText } from "@/utils/tile.utils";

interface UseBulkInsertProps {
  onComplete?: (result: { success: number; failed: number }) => void;
  onError?: (error: string) => void;
}

export const useBulkInsert = ({ onComplete, onError }: UseBulkInsertProps) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [progress, setProgress] = React.useState({ completed: 0, total: 0 });

  const insertAllTiles = async (items: ReviewTileItem[]) => {
    setIsProcessing(true);
    setProgress({ completed: 0, total: items.length });

    let successCount = 0;
    let failedCount = 0;

    try {
      for (const [index, item] of items.entries()) {
        try {
          await Word.run(async (context) => {
            const tileText = getTileContentAsText(item);
            const paragraphs = tileText.split("\n").filter((p) => p.trim() !== "");
            const body = context.document.body;
            paragraphs.forEach((pText) => {
              const parts = pText.split(/: (.+)/); // Split on the first colon, keeping the rest
              const label = parts[0];
              const value = parts[1];

              if (label && value) {
                const p = body.insertParagraph("", Word.InsertLocation.end);
                p.insertText(label + ": ", "Start").font.bold = true;
                p.insertText(value, "End").font.bold = false;
              } else {
                body.insertParagraph(pText, Word.InsertLocation.end);
              }
            });

            if (paragraphs.length > 0) {
              body.insertParagraph("", Word.InsertLocation.end); // Add a blank paragraph for spacing
            }
          });
          successCount++;
        } catch (error) {
          console.error("Error inserting tile:", item, error);
          failedCount++;
        }
        setProgress({ completed: index + 1, total: items.length });
      }

      onComplete?.({ success: successCount, failed: failedCount });
    } catch (error) {
      console.error("Error in bulk insert:", error);
      onError?.((error as Error).message);
    } finally {
      setIsProcessing(false);
    }
  };

  return { isProcessing, progress, insertAllTiles };
};
